/*
 * Neckwear catalog — a second accessory slot beside hats. Added 2026-05-17 as a
 * structural placeholder for content TASK-04 spec'd (bumbleknit scarf, etc.).
 *
 * The slot exists so the SaveData schema is forward-compatible; only 'none' ships
 * in v0.3. As neck items land they're APPENDED here — indices are persistent,
 * never reorder.
 *
 * The unlock schema mirrors HatUnlock so the unlock checker can be reused.
 */

import type { HatUnlock } from '@/content/hats';

/** Reuse the hat unlock condition shape — no need for a parallel union. */
export type NeckUnlock = HatUnlock;

export interface Neckwear {
  /** Canonical name. Used as the unlock key in SaveData.neckUnlocks. */
  name: string;
  /** null = always available; otherwise the threshold that unlocks it. */
  unlock: NeckUnlock | null;
  /** Player-facing hint shown when they tap a locked item. */
  hint?: string;
}

export const NECKWEAR: readonly Neckwear[] = [
  { name: 'none', unlock: null },
  // Future entries land here. CONTENT_CATALOG.md tracks the design spec
  // (e.g. bumbleknit scarf) until the visual art ships.
] as const;

/** Items unlocked by default. */
export const DEFAULT_NECK_UNLOCKS: readonly string[] = ['none'];

/** Safe lookup; falls back to 'none' if index is out of range. */
export function neckAt(index: number): Neckwear {
  return NECKWEAR[index] ?? NECKWEAR[0]!;
}

/** True if the catalog has anything beyond 'none' worth showing in the customizer. */
export function hasNeckItems(): boolean {
  return NECKWEAR.length > 1;
}
